import { memo, useCallback, useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import TextArea from 'components/textArea';
import CampaignFormFieldGroup from '../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import CampaignFormField from '../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import { CampaignFormStepTwoContext } from '../../../../campaignFormStepTwo.context';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';

const ContentFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);
  const { validateDocumentOrSnsPlatformsInText } = useContext(CampaignFormStepTwoContext);

  const contentValue = useWatch({
    control: guidelineRuleFormMethods.control,
    name: 'CONTENT.value',
  });

  const onClickDescription = useCallback(() => {
    const [subtitleOpening, subtitleMiddle, subtitleClosing] = guidelineRuleFormMethods.getValues([
      'SUBTITLE_OPENING',
      'SUBTITLE_MIDDLE',
      'SUBTITLE_CLOSING',
    ]);
    const content = [
      subtitleOpening?.value,
      ...subtitleMiddle.map((middle) => middle?.value || ''),
      subtitleClosing?.value,
    ]
      .filter(Boolean)
      .join('\n')
      .trim();

    guidelineRuleFormMethods.setValue('CONTENT.value', content);
  }, []);

  return (
    <CampaignFormFieldGroup label={`4. ${languageTexts.create_reels_form_contents}`} bordered>
      <CampaignFormField
        as="div"
        description={
          <span className="cursor-pointer underline" onClick={onClickDescription}>
            {languageTexts.create_reels_form_load_contents_from_subtitles}
          </span>
        }
        descriptionClassName="!text-[16px] !font-normal !text-[#000]"
      >
        <TextArea
          bordered
          placeholder={languageTexts.input}
          value={contentValue || ''}
          rows={5}
          register={guidelineRuleFormMethods.register('CONTENT.value', {
            onBlur: (event) => validateDocumentOrSnsPlatformsInText(event?.target?.value || ''),
          })}
          autoResize={true}
          inputStyle={{ display: 'block', minHeight: '151.04px' }}
        />
      </CampaignFormField>
    </CampaignFormFieldGroup>
  );
};

export default memo(ContentFieldGroup);
